import React from "react";
import './styles.css'

interface CardProps {
  title: string;
  value?: string;
  icon: React.ReactNode;
}

function AverageCard(props: CardProps) {
  return (
    <div className="average-card">
      <div className="card-left">
        <p>{props.title}</p>
        <h2>{props.value}</h2>
      </div>
      <div className="card-icon-wrapper">{props.icon}</div>
    </div>
  );
}

export default AverageCard;
